export default __webpack_public_path__ + "static/media/download.883dad6a.svg";